import { Box, Typography } from "@mui/material";

export default function FirstRow() {
  const bulletPoints = [
    "dostęp w krótkim czasie do specjalistów IT",
    "doświadczenie pracowników outsourcera gwarantuje szybką, sprawną realizację usługi oraz trafne decyzje związane z usługą",
    "koszt usługi jest stały, nie ulega zmianie",
    "outsourcer stwarza możliwość skoncentrowania się na podstawowej działalności oraz kluczowych klientach",
    "proces zarządzany jest kompleksowo, głównie pod kątem wymagań biznesowych i uzgodnionych parametrów usługi, tj. SLA i KPI",
    "usługa zarządzana jest przez dedykowanego dla Klienta Technical Account Managera, a Klient jest odbiorcą finalnym usługi",
    "wartość dodana – wysoka jakość i bezpieczeństwo realizacji usługi",
    "klient nie musi rozbudowywać zasobów środków trwałych",
    "rotacja pracowników IT nie dotyczy Klienta. Outsourcing procesów IT jest tak zdefiniowany, aby Klient miał zagwarantowaną ciągłość usługi",
    "koszty outsourcingu zaklasyfikowane są jako koszty Opex – koszty operacyjne mające na celu wsparcie dla biznesu. Outsourcing nie jest też zaliczany do grupy Labor Opex, ale jako wydatki operacyjne.",
  ];
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        width: "100%",
        
        paddingTop: { xs: "0", md: "50px" },
      }}
    >
      {/* lewa kolumna w poprzednim ukladzie (teraz jest w komponencie Row) */}
      

      {/* prawa kolumna */}
      <Box
        sx={{
          backgroundColor: "white",
          flex: { xs: "none", md: "1 1 auto" },
          p: { xs: 2, md: 4 },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Outsourcing polega na przejęciu do realizacji wydzielonego procesu
          biznesowego IT przez wyspecjalizowane firmy.
        </Typography>

        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Outsourcer, mając większe doświadczenie, potrafi szybciej i sprawniej
          wykonać projekty IT, często w niższej cenie.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Korzyścią biznesową jest stworzenie Klientowi warunków do zajęcia się
          kluczową działalnością działu IT oraz samego przedsiębiorstwa.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Usługa outsourcingowa jest bardzo elastyczna i można modelować ją
          według potrzeb Klienta.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "22px", md: "25px" },
            fontWeight: "bold",
            color: "#29235C",
            mb: 1,
          }}
        >
          Podstawowe korzyści wynikające z tej usługi:
        </Typography>

        <Box component="ul" sx={{ pl: 3, m: 0 }}>
          {bulletPoints.map((item, index) => (
            <Box
              component="li"
              key={index}
              sx={{
                fontFamily: "Segoe UI",
                fontSize: { xs: "18px", md: "20px" },
                color: "#29235C",
                mb: 0,
                "&::marker": {
                  color: "#FF5700",
                },
              }}
            >
              {item}
            </Box>
          ))}
        </Box>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
            mt:2,
          }}
        >
          Specjalizujemy się między innymi w realizacji usług dotyczących
          outsourcingu procesów biznesowych IT, obejmujących organizację i
          zarządzanie Service Desk/Help Deskiem.
        </Typography>
        <Typography
          sx={{
            fontFamily: "Segoe UI",
            fontSize: { xs: "18px", md: "20px" },
            color: "#29235C",
            mb: 2,
          }}
        >
          Posiadamy wysoko wykwalifikowanych specjalistów IT, którzy doradzą i
          pomogą w modelowaniu usługi na etapie tworzenia umowy współpracy, SLA,
          czy katalogu usług. Dobrze skonstruowane SLA jest połową sukcesu w
          realizacji i zarządzaniu tą usługą.
        </Typography>
      </Box>
    </Box>
  );
}
